<template>
<div>

    <v-app-bar fixed height=65>
        <!-- <v-app-bar-nav-icon></v-app-bar-nav-icon> -->
         <div class="d-flex align-center">
            <v-img
            alt="Vuetify Logo"
            
            :src="storeLogo"
            transition="scale-transition"
            max-height='50'
            max-width="250"
            />
            <!-- <v-spacer></v-spacer> -->
         </div>
         <v-spacer></v-spacer>
         <!-- <v-img></v-img> -->
           <v-btn icon append :to="{name:'Cart'}"> 
                <v-icon>mdi-cart-outline</v-icon>
            </v-btn>
            <v-btn icon>
                <v-icon>mdi-account-circle-outline</v-icon>
            </v-btn>
        
    </v-app-bar>
    <v-container class='mt-15'>
         <h1>Login Less</h1>
    </v-container>

   
</div>
    
</template>
<style scoped>

</style>
<script>
export default {
    name:'LoginLess'
}
</script>